"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = logError;

function logError(location, error) {
  if (window.newrelic) {
    var errorCode = error.errorCode,
        errorMessage = error.errorMessage,
        message = error.message,
        responseJSON = error.responseJSON,
        status = error.status,
        data = error.data;
    window.newrelic.addPageAction('ui-addon-upgrades-error', {
      location: location,
      errorCode: errorCode,
      errorMessage: errorMessage,
      message: message,
      responseJSON: responseJSON,
      status: status,
      data: data
    });
  }
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/reliability/logError.js
// module id = 240
// module chunks = 5 6